<template>
  <div class="form-container p-4 my-4">
    <b-form-group :label="FormMSG(1, 'Invoice date')">
      <v-date-picker v-model="$v.electronicInvoice.date.$model">
        <template #default="{ inputValue, togglePopover }">
          <b-input-group class="w-100">
            <b-form-input
              :value="inputValue"
              class="form-control"
              style="border-radius: 10px 0 0 10px"
              placeholder="DD/MM/YYYY"
              readonly
              @click="togglePopover()"
            />
            <b-input-group-append style="cursor: pointer">
              <b-input-group-text class="input-group-text bgc-grey-light" @click="togglePopover()">
                <component :is="getLucideIcon('Calendar')" :size="20" :stroke-width="2" />
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </template>
      </v-date-picker>
      <div v-if="$v.electronicInvoice.date.$error" class="invalid-feedback">
        {{ FormMSG(6, 'Invoice date is required') }}
      </div>
    </b-form-group>
    <b-form-group>
      <template slot="label">
        <label class="pt-1" for="invoiceNumber">{{ FormMSG(2, 'Invoice Number') }}</label>
      </template>
      <b-form-input v-model="$v.electronicInvoice.invoiceNumber.$model" placeholder="0" />
      <div v-if="$v.electronicInvoice.invoiceNumber.$error" class="invalid-feedback">
        {{ FormMSG(7, 'Invoice number is required and must be valid') }}
      </div>
    </b-form-group>
    <b-form-group>
      <template slot="label">
        <label class="pt-1" for="invoiceDescription">{{ FormMSG(3, 'Description') }}</label>
      </template>
      <b-form-textarea
        v-model="$v.electronicInvoice.description.$model"
        class="description-overflow"
        :placeholder="FormMSG(4, 'add some description here...')"
        :rows="2"
      />
      <div v-if="$v.electronicInvoice.invoiceNumber.$error" class="invalid-feedback">
        {{ FormMSG(8, 'Invoice description is required') }}
      </div>
    </b-form-group>
    <b-form-group class="flex-grow-1">
      <template slot="label">
        <label class="pt-1" for="amountTotal">{{ FormMSG(5, 'Total Amount') }}</label>
      </template>
      <b-input-group>
        <b-form-input
          v-model="$v.electronicInvoice.amountTotal.$model"
          type="number"
          step="0.01"
          min="0"
          placeholder="0"
          lazy
          lazy-formatter
          number
          :formatter="roundNumeric"
        />
        <b-input-group-append>
          <b-input-group-text>
            <currency-svg color="#06263E" opacity="0.85" width="15" height="15" />
          </b-input-group-text>
        </b-input-group-append>
      </b-input-group>
      <div v-if="$v.electronicInvoice.amountTotal.$error" class="invalid-feedback">
        {{ FormMSG(34, 'Total amount should not be empty') }}
      </div>
    </b-form-group>
  </div>
</template>

<script>
import CurrencySvg from '@/components/Svg/Currency';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import globalMixin from '@/mixins/global.mixin';
import languageMessages from '@/mixins/languageMessages';
import invoicesToolsMixin from '@/mixins/invoicesTools.mixin';
import moment from 'moment';
import { validationMixin } from 'vuelidate';
import { required, decimal, minLength } from 'vuelidate/lib/validators';
import { greaterThanZero } from '@/shared/utils';

export default {
  name: 'ElectronicInvoiceForm',
  components: {
    CurrencySvg,
    'v-date-picker': DatePicker
  },
  mixins: [languageMessages, globalMixin, invoicesToolsMixin, validationMixin],
  props: {
    electronicData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      electronicInvoice: {
        date: moment().utc().format('DD/MM/YYYY'),
        invoiceNumber: '',
        description: '',
        amountTotal: 0
      }
    };
  },
  watch: {
    electronicData: {
      handler(newVal) {
        this.electronicInvoice = {
          date: newVal.date || this.electronicInvoice.date,
          invoiceNumber: newVal.invoiceNumber || this.electronicInvoice.invoiceNumber,
          description: newVal.description || this.electronicInvoice.description,
          amountTotal: newVal.amountTotal || this.electronicInvoice.amountTotal
        };
      },
      deep: true,
      immediate: true
    },
    electronicInvoice: {
      handler(newVal) {
        this.$v.$touch();
        this.$emit('change', { valid: !this.$v.$invalid, data: newVal });
      },
      deep: true,
      immediate: true
    }
  },
  validations() {
    return {
      electronicInvoice: {
        date: { required },
        invoiceNumber: {
          required,
          min: minLength(2)
        },
        description: {
          required,
          min: minLength(4)
        },
        amountTotal: {
          required,
          decimal,
          greaterThanZero
        }
      }
    };
  }
};
</script>

<style scoped>
.form-container {
  border: 1px dashed #ccc;
  border-radius: 5px;
}

.description-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
